import { mergeLeft, mergeLeftDropping } from 'merge-left-utils'

export interface BatchCreateStorageContainerFormState {
  count: number
  size: string
  type: string
  description: string
  is_active: boolean
  prefix: string
  
  sanitization_interval_days?: number
  next_sanitize_at?: Date | null
}

export const BATCH_CREATE_CONTAINER_DEFAULT_STATE: BatchCreateStorageContainerFormState = {
  count: 10,
  size: 'M',
  type: 'container',
  description: '',
  is_active: true,
  prefix: 'SC',
  
  sanitization_interval_days: undefined,
  next_sanitize_at: null
}

export const makeBatchCreateStorageContainerFormState = (): BatchCreateStorageContainerFormState => {
  return { ...BATCH_CREATE_CONTAINER_DEFAULT_STATE }
}

export const mapStateToApiVariable = (state: BatchCreateStorageContainerFormState): any =>
  mergeLeftDropping([], BATCH_CREATE_CONTAINER_DEFAULT_STATE, {
    ...state,
    count: Number(state.count),
    sanitization_interval_days: Number(state.sanitization_interval_days) > 0 ? Number(state.sanitization_interval_days) : undefined,
    next_sanitize_at: state.next_sanitize_at ? new Date(state.next_sanitize_at).getTime() : undefined
  })
